export default __webpack_public_path__ + "static/media/14.37f0ae1a.jpg";